enum ModalViews {
  PRESS = "PRESS",
  ORDERS = "ORDERS",
  INFO = "INFO",
  GAMES = "MY GAMES",
  HELP = "HELP",
  CONTROL = "CONTROL",
}

export default ModalViews;
